export default __webpack_public_path__ + "static/media/view-dark.4934b733.svg";